import React from 'react';
import { Navigate } from 'react-router-dom';

/*** GUARDS */
import AuthGuard from '../guards/auth.guard';
import LoggedOutGuard from '../guards/logged-out.guard';

/* ***Layouts**** */
const App = React.lazy(() => import("../shade/layouts/App"));
/* ***End Layouts**** */

/* ***Authentication**** */
const AuthLogin = React.lazy(() => import("../components/Authentication/Login/Login"));

/* ****Pages***** */
const Beginning = React.lazy(() => import("../components/Beginning/Beginning"));

/* ****Proyecto elecciones***** */
const Command = React.lazy(() => import("../components/Dashboard/Command/Command"));
const Candidate = React.lazy(() => import("../components/Dashboard/Candidates/Candidate"));
const Leader = React.lazy(() => import("../components/Dashboard/Leaders/Leader"));
const Voters = React.lazy(() => import("../components/Dashboard/Voters/Voters"));
const Digitizer = React.lazy(() => import("../components/Dashboard/Digitizers/Digitizer"));
const ManageLookouts = React.lazy(() => import("../components/Dashboard/ManageLookouts/ManageLookouts"));
const ManageWitnesses = React.lazy(() => import("../components/Dashboard/ManageWitnesses/ManageWitnesses"));
const ElectionWitnesses = React.lazy(() => import("../components/Dashboard/ElectionWitnesses/ElectionWitnesses"));
const ManageTables = React.lazy(() => import("../components/Dashboard/ManageTables/ManageTables"));
const MobileCommand = React.lazy(() => import("../components/Dashboard/MobileCommand/MobileCommand"));
const News = React.lazy(() => import("../components/Dashboard/News/News"));
const BackOffice = React.lazy(() => import("../components/Dashboard/BackOffice/BackOffice"));
const VoteReport = React.lazy(() => import("../components/Dashboard/VoteReport/VoteReport"));
const Indicator = React.lazy(() => import("../components/Dashboard/Indicators/Indicator"));
const VotingAreasMap = React.lazy(() => import("../components/Dashboard/Zones/VotingAreasMap"));

/* ****Routes***** */
const Router = [
  {
    path: '/',
    children: [
      { path: `/`, element: <Navigate to="/auth/login" /> },
      { path: '*', element: <Navigate to="/auth/login" /> },
    ],
  },
  {
    element: <AuthGuard />,
    children: [
      {
        path: '/dashboard',
        element: <App />,
        children: [
          { path: 'inicio', exact: true, element: <Beginning /> },
          { path: 'comando', exact: true, element: <Command /> },
          { path: 'candidatos', exact: true, element: <Candidate /> },
          { path: 'lideres', exact: true, element: <Leader /> },
          { path: 'votantes/:typeOfUser/:urlId/:loadInitialData', exact: true, element: <Voters /> },
          { path: 'digitadores', exact: true, element: <Digitizer /> },
          { path: 'vigias', exact: true, element: <ManageLookouts /> },
          { path: 'administrar-testigos', exact: true, element: <ManageWitnesses /> },
          { path: 'testigos-electorales', exact: true, element: <ElectionWitnesses /> },
          { path: 'gestionar-mesas', exact: true, element: <ManageTables /> },
          { path: 'comando-movil', exact: true, element: <MobileCommand /> },
          { path: 'novedades', exact: true, element: <News /> },
          { path: 'oficina-administrativa', exact: true, element: <BackOffice /> },
          { path: 'reporte-de-votos', exact: true, element: <VoteReport /> },
          { path: 'indicadores', exact: true, element: <Indicator /> },
          { path: 'zonas', exact: true, element: <VotingAreasMap /> },
    
          { path: '*', element: <Navigate to="/auth/login" /> },
        ],
      }
    ],
  },
  {
    element: <LoggedOutGuard />,
    children: [
      {
        path: `/auth`,
        children: [
          //{ path: '404', element: <Error /> },
          { path: 'login', element: <AuthLogin /> },
          { path: '*', element: <Navigate to="/auth/login" /> },
        ],
      }
    ]
  }
];

export default Router;